import React, { Suspense } from 'react'
import PageLoader from '../../component/Elements/pageLoader'
import { lazyWithRetry } from '../../helper/lazyWithRetry'

const FranchiseProductSalesReport = lazyWithRetry(() => import(/* webpackChunkName: "FranchiseProductSalesReport" */'../../component/FranchiseOfficeReports/FranchiseProductSalesReport'))

const FranchiseProductSalesReportPage = React.memo(() => {
	return (
		<Suspense fallback={<PageLoader />}>
			<FranchiseProductSalesReport />
		</Suspense>
	)
})

FranchiseProductSalesReportPage.displayName = 'FranchiseProductSalesReportPage'
export default FranchiseProductSalesReportPage
